export default __webpack_public_path__ + "static/RussellJohnson-651fb31084d693814623f72ec6171bc2.jpg";